const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: (token, email, userid) => ({
    type: actions.LOGIN_REQUEST,
    payload: { token, email, userid },
  }),
  // loginSuccess: (token) => ({
  //   type: actions.USER_NAME,
  //   payload: { 
  //     name, persona 
  //   },
  // }),
  logout: () => ({
    type: actions.LOGOUT,
  }),
};
export default actions;
